export default __webpack_public_path__ + "static/media/ic_calendar.f1a8d3f0.svg";